<template>
  <div class="popup" :class="isPopupClass">
    <Header />
    <perfect-scrollbar class="popup_scroll" ref="popupScroll">
      <router-view class="contents"></router-view>
    </perfect-scrollbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Header from '@/components/modules/exchange/Header';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import eventBus from '@/utils/eventBus';

export default {
  components: {
    Header,
    PerfectScrollbar,
  },
  data() {
    return {
      isPopupClass: '',
    };
  },
  methods: {
    ...mapActions(['setExchangeIframe']),
    scrollTop() {
      this.$nextTick(() => {
        this.$refs.popupScroll.$el.scrollTop = 0;
      });
    },
    scrollUpdate() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.popupScroll.update();
        }, 200);
      });
    },
    updateVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
  },
  mounted() {
    eventBus.$on('scrollUpdate', this.scrollUpdate);
    eventBus.$on('scrollTop', this.scrollTop);
    this.scrollUpdate();
    this.$nextTick(() => {
      const parentPath = window.parent.location.href.split(/[/?]/)[5];
      if (parentPath === 'exchangeHistory' || parentPath === 'pointHistory') {
        this.setExchangeIframe(true);
        setTimeout(() => {
          this.isPopupClass = 'popup_frame';
          this.updateVh();
        }, 200);
      }
    });

    window.addEventListener('resize', this.updateVh);
    window.addEventListener('orientationchange', this.updateVh());
  },
  beforeDestroy() {
    eventBus.$off('scrollUpdate', this.scrollUpdate);
    eventBus.$off('scrollTop', this.scrollTop);
    window.removeEventListener('resize', this.updateVh);
  },
};
</script>
